let Vue = require('vue');
// let client = require('../../helpers/client');
let mercadoLivreConfigTemplate = require('templates/portals/ui-mercadolivre-configurations.html');


Vue.component('mercadolivre-configs', {
    twoWay: true,
    template: mercadoLivreConfigTemplate,
    props: {
        name : {
            type: String,
            default: ''
        }
    },
    data: () => ({

    }),
    methods: {

    }
});


// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/portals/mercadolivre-configurations.js